import { SP_AUTH_REDIRECT_KEY } from "./constants";
import { readPendingRecord } from "./utils";

export const getSharepointAuthRedirect = () =>
  readPendingRecord(SP_AUTH_REDIRECT_KEY);
